import { useEffect } from "react";
import { useTitle } from "../../contexts/title";
import { MyAccountControl } from "../../features/common";

export default function Profile() {
	const pageTitle = useTitle();

	useEffect(() => {
		pageTitle.setTitle('My Account');
	}, [pageTitle])

	return (
		<div className="content-block">
			<MyAccountControl></MyAccountControl>
		</div>
	);
}
